import { BOAT_LENGTH_M, metersToPixels } from '../sim/constants.ts';

/**
 * Floor for the painted hull length while placing / aiming. Below this screen size the
 * 7 m sprite becomes a speck when the player wheels out; plant and collision stay metric.
 */
export const HULL_MIN_SCREEN_PX = 32;

export type HullDisplaySize = {
  displayW: number;
  displayH: number;
};

/**
 * World `setDisplaySize` for a hull at the given camera zoom. When zoom would paint the
 * boat shorter than `minScreenPx`, grows the sprite so it stays readable. Non-finite or
 * non-positive zoom returns the metric footprint.
 */
export function hullDisplaySize(
  zoom: number,
  lengthM = BOAT_LENGTH_M,
  beamM = lengthM / 2,
  minScreenPx = HULL_MIN_SCREEN_PX,
): HullDisplaySize {
  const metricW = metersToPixels(lengthM);
  const metricH = metersToPixels(beamM);

  if (!Number.isFinite(zoom) || zoom <= 0) {
    return { displayW: metricW, displayH: metricH };
  }

  const displayW = Math.max(metricW, minScreenPx / zoom);
  const displayH = displayW * (metricH / metricW);

  return { displayW, displayH };
}

/** Metric 7 m × half-beam footprint used once the race has started. */
export function metricHullDisplaySize(
  lengthM = BOAT_LENGTH_M,
  beamM = lengthM / 2,
): HullDisplaySize {
  return {
    displayW: metersToPixels(lengthM),
    displayH: metersToPixels(beamM),
  };
}
